import IMask from 'imask'

const telephoneMask = () => {
   const telInputs = document.querySelectorAll('input[type=tel]')

   telInputs.forEach((telInput) => (

      telInput.addEventListener('keyup', () => {
         const aditionalCharacters = 4;
         const landlineLength = 10 + aditionalCharacters

         IMask(telInput, {mask: '(00) 0000-00000'})

         if( telInput.value.length > landlineLength )
            IMask(telInput, {mask: '(00) 00000-0000'})
      })
   ))
}

telephoneMask()


// WEBPACK FOOTER //
// ./scripts/masks/telephone.js